<template>
  <div class="user-info-rebate-wrapper">
    <display-navigation title="会员充值" path="user_info" />
    <div class="content-wrapper">
      <van-field
        size="large"
        type="number"
        class="input"
        placeholder="请输入充值金额"
        :value="value"
        @input="handleChange"
      >
        <template v-slot:left-icon>
          <span>￥</span>
        </template>
      </van-field>
    </div>
    <div class="action-wrapper">
      <van-button
        block
        class="btn"
        type="primary"
        :loading="loading"
        :disabled="loading"
        @click="handleSubmit"
        >确认充值</van-button
      >
    </div>
    <van-cell title="充值规则：" class="rules-wrapper">
      <template #label>
        <div v-html="keys.content"></div>
      </template>
    </van-cell>
  </div>
</template>

<script>
import { createRechargeDetail, Memberset } from '@/api/api-user';
import DisplayNavigation from '@/components/DisplayNavigation';

export default {
  components: {
    DisplayNavigation,
  },
  data() {
    return {
      value: undefined,
      loading: false,
      content: '123',
      keys: {},
    };
  },
  created() {
    this.handleGet();
  },
  methods: {
    handleChange(val) {
      this.value = parseFloat(val);
    },
    checkFields() {
      return new Promise((resolve, reject) => {
        if (!this.value || this.value < 0.01) reject(new Error('充值金额不能小于￥0.01'));
        const decimal = this.value.toString().split('.')[1];
        if (decimal && decimal.length > 2) reject(new Error('充值金额格式有误'));
        resolve(this.value);
      });
    },
    back() {
      this.$router.push({ name: 'user_info' });
    },
    //     async rule(){
    // try {
    //   const data = await createRechargeDetail({ spot_id:id });
    // } catch (error) {

    // }
    //     } ,
    async handleGet() {
      try {
        const spotId = window.sessionStorage.getItem('spotId');
        const data = await Memberset({ spot_id: spotId });
        this.keys = { ...data };
      } catch (e) {}
    },
    async handleSubmit() {
      try {
        const money = await this.checkFields();
        this.loading = true;
        const config = await createRechargeDetail({ money });
        if (config && window.WeixinJSBridge) {
          window.WeixinJSBridge.invoke('getBrandWCPayRequest', config, res => {
            if (res.err_msg === 'get_brand_wcpay_request:ok') {
              this.$router.push({ name: 'user_info' });
            }
          });
        }
      } catch (e) {
        this.$toast.fail(e.message);
      }
      this.loading = false;
    },
  },
};
</script>

<style lang="less" scoped>
.user-info-rebate-wrapper {
  .content-wrapper {
    background: #fff !important;
    .input {
      margin: 8px 0;
    }
  }
  .action-wrapper {
    margin: 16px;
  }
  .rules-wrapper {
    background: transparent;
  }
}
</style>
